/* src/app/components/analytics/custodians/custodian/custodian.component.scss */
.add-custodian-button {
  margin-top: 10px;
  margin-bottom: -10px;
  margin-left: 20px;
  z-index: 10;
}
/*# sourceMappingURL=custodian.component.css.map */
